import { Link } from "react-router-dom";

export function Logo({ size = "md", to = "/", onClick }) {
  const dims = size === "sm" ? "h-7 w-7" : size === "lg" ? "h-11 w-11" : "h-9 w-9";
  const text = size === "sm" ? "text-lg" : size === "lg" ? "text-2xl" : "text-xl";
  const inner = (
    <div className="flex items-center gap-2.5" data-testid="nexora-logo">
      <div className={`${dims} relative rounded-xl bg-gradient-to-br from-indigo-500 via-indigo-600 to-cyan-500 flex items-center justify-center glow-sm`}>
        <div className="absolute inset-[3px] rounded-[9px] bg-[#07090E] flex items-center justify-center">
          <span className="font-heading font-black text-transparent bg-clip-text bg-gradient-to-br from-indigo-300 to-cyan-300 text-sm">N</span>
        </div>
      </div>
      <span className={`font-heading font-bold ${text} tracking-tight`}>NEXORA<span className="text-indigo-400"> AI</span></span>
    </div>
  );
  if (onClick) return <button onClick={onClick} className="focus:outline-none">{inner}</button>;
  return <Link to={to} className="focus:outline-none">{inner}</Link>;
}
